import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const UnitTableContainer = Loadable({
    loader: () => import('../../Containers/Unit/UnitTableContainer'),
    loading: Loading,
});
const CreateUnitContainer = Loadable({
    loader: () => import('../../Containers/Unit/CreateUnitContainer'),
    loading: Loading,
});

const unitRoutes = [
    { path: '/unit/list', exact: true, name: 'Unidades', component: UnitTableContainer },
    { path: '/unit/create', exact: true, name: 'Nueva Unidad', component: CreateUnitContainer },
];

export default unitRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/unit.js